// extracted by mini-css-extract-plugin
export default {"imdiLogo":"ImdiLogo_imdiLogo__hy6SB"};